import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-emotion-sad-line text-3xl" />
      </span>
      <h1 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-5xl">页面未找到</h1>
      <p className="mt-3 font-mono text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你访问的页面可能已被移除或路径有误，返回首页继续浏览忍者世界的精彩内容。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/episodes"
          className="rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
        >
          浏览剧集
        </Link>
      </div>
    </div>
  );
}